"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadNewsRequest = void 0;
var ReadNewsRequest = /** @class */ (function () {
    function ReadNewsRequest() {
    }
    return ReadNewsRequest;
}());
exports.ReadNewsRequest = ReadNewsRequest;
;
//# sourceMappingURL=readNews.request.js.map